/**
 *
 * Autocomplete
 *
 */

import React, { Fragment } from "react"
import { AutoComplete as AutoInput } from "antd"
import { flatMap, debounce } from "lodash"
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons"
import IconLupaDisabled  from "./IconLupaDisabled"
/* eslint-disable react/prefer-stateless-function */
class AutoComplete extends React.Component {
  state = {
    text: "",
    searching: false,
    options: [],
  }

  handleSearch = async () => {
    this.setState({ searching: true })
    if (this.props.url) {
      try {
        const items = await fetchGlobalApi({
          method: "GET",
          endpoint: this.props.url + this.state.text,
        })
        this.setState({
          searching: false,
          options: flatMap(items.data.data.result.search_filter, (item) => {
            return { value: item.name }
          }),
        })
        this.forceUpdate()
      } catch (error) {
        this.setState({ searching: false })
      }
    }
  }

  render() {
    return (
      <Fragment>
        <div style={{ position: "relative" }}>
          <AutoInput
             disabled = {this.props.disabled}
            style={{ width: "100%" }}
            allowClear={this.props.allowClear}
            options={
              this.state.text &&
              this.state.text.length > 0 &&
              !this.state.searching
                ? this.state.options
                : []
            }
            placeholder={this.props.placeholder}
            onSelect={this.props.onSelect}
            onInputKeyDown={(e) => {
              if (e.key === "Enter") this.props.onSelect(this.state.text)
            }}
            defaultActiveFirstOption={false}
            onChange={debounce((e) => {
              if (!e || e === "")
                return this.setState({ text: e }, () => this.props.onSelect(""))
              this.setState({ text: e }, () => this.handleSearch())
            }, 500)}
          />
          {
            <div
              style={{
                position: "absolute",
                top: 2,
                right: 11,
                zIndex: 1,
                background: !this.props.disabled ? "white" : "transparent",
              }}>
                { !this.props.disabled &&
                    <SearchOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.props.onSelect(this.state.text)
                    }}
                  />
                }
                { this.props.disabled &&
                  <IconLupaDisabled
                  fill={"#A7A3A3"} />   
                  
                  
                }
       
            </div>
          }
          {this.state.searching &&
            this.state.text &&
            this.state.text.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: 2,
                  right: 11,
                  zIndex: 1,
                  background: "white",
                }}>
                <LoadingOutlined />
              </div>
            )}
        </div>
      </Fragment>
    )
  }
}
AutoComplete.defaultProps = {
  url: null,
  allowClear: false,
  onSelect: () => {},
  placeholder: "Buscar...",
  options: [],
  disabled:false,
}

export default AutoComplete
